import { updateStatusReq } from 'interface/capital.interface';
import axiosClient from './axiosClient';
import { IPagination } from 'interface/base.interface';

const path = 'abe/capital';

const CapitalApi = {
  getCapitalShop: (id: any, year: any, params?: IPagination): Promise<any> => {
    if (year != null && year != undefined) {
      return axiosClient.get(`/${path}/get-capital-shop/${id}?year=${year}`, {
        params,
      });
    } else {
      return axiosClient.get(`/${path}/get-capital-shop/${id}`, {
        params,
      });
    }
  },

  getCapitalProductsTVV: (id: any): Promise<any> => {
    return axiosClient.get(`/abe/cart-order-tvv/get-dong-hang/${id}`);
  },
  getCapitalProductsCHT: (id: any): Promise<any> => {
    return axiosClient.get(`/abe/cart-order/cht/get-dong-hang/${id}`);
  },
  getYearOptionList: (branch_id?: any): Promise<any> => {
    return axiosClient.get(`/${path}/option-list?branch_id=${branch_id}`);
  },

  getCapitalShopApprove: (params: any): Promise<any> => {
    return axiosClient.get(`/${path}/get-capital-shop-to-approve`, { params });
  },
  putUpdateStatus: (params?: updateStatusReq): Promise<any> => {
    return axiosClient.put(`/${path}/update-status`, {
      list_capital_id: params?.list_capital_id,
      status: params?.status,
      reject_reason: params?.reject_reason,
    });
  },
  getCapitalShopDetail: (shop_id: any): Promise<any> => {
    return axiosClient.get(`/${path}/get-capital-shop/${shop_id}`);
  },
  getlogApprove: (id: any): Promise<any> => {
    return axiosClient.get(
      `/${path}/list-log-approve?capital_shop_id=${id}&order_by=created_at&order_type=DESC`
    );
  },
  checkTuXmanDiff: (params: any): Promise<any> => {
    return axiosClient.get(`/abe/capital-shop/tu-xman-diff`, {
      params: params,
    });
  },
};

export default CapitalApi;
